import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useTemplateRef, PropType } from 'vue'
    
    enum Size {
        small = "small",
        normal = "normal",
        large = "large"
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'confirm_button',
  props: {
        disabled: {
            type: Boolean as PropType<boolean>,
            default() {
                return false
            }
        },
        size: {
            type: String as PropType<Size>,
            default() {
                return Size.normal
            }
        }
    },
  emits: ['click'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    const props = __props

    const emit = __emit
    const prop_disabled = computed(() => props.disabled)
    const prop_size = computed(() => props.size)
    
    const ref_dialog = useTemplateRef('dialog')

    const dat_paused = ref(false)



    function open_confirmarion_modal() {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        if (loc_dialog === null) {
            return
        }

        loc_dialog.showModal()        
    }

    function cancel() {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        
        if (loc_dialog === null) {
            return
        }

        loc_dialog.close()
    }

    function clicked(event: MouseEvent) {
        const loc_dialog: HTMLDialogElement | null = ref_dialog.value
        if (loc_dialog === null) {
            return
        }

        loc_dialog.close()

        emit('click')
    }

const __returned__ = { Size, props, emit, prop_disabled, prop_size, ref_dialog, dat_paused, open_confirmarion_modal, cancel, clicked }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})